import React from "react";
import { useAuth } from "../context/AuthContext";
import { BRAND } from "../mock";
import { Button } from "../components/ui/button";
import { Clock, LogOut, ShieldAlert } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const declined = user?.status === "declined";
  return (
    <div className="min-h-screen grid place-items-center bg-background px-6" data-testid="pending-screen">
      <div className="w-full max-w-md rounded-2xl border border-white/[0.06] bg-card/40 p-8 text-center">
        <img src={BRAND.logo} alt="Moroccan Brothers" className="mx-auto h-28 w-auto max-w-[340px] object-contain" />
        <div className={`mx-auto mt-5 grid h-12 w-12 place-items-center rounded-full ${declined ? "bg-brand-red/15" : "bg-brand-green/15"}`}>
          {declined ? <ShieldAlert className="h-6 w-6 text-brand-red" /> : <Clock className="h-6 w-6 text-brand-green" />}
        </div>
        <h1 className="mt-4 font-display text-2xl font-semibold text-white">{declined ? "Access not approved" : "Awaiting approval"}</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground" data-testid="pending-message">
          {declined ? (
            <>Your access request wasn't approved. If you're on the programme, please reach out to your success manager at Moroccan Brothers.</>
          ) : (
            <>Thanks {user?.name?.split(" ")[0]}! Someone from the Moroccan Brothers team needs to approve your account before you get access. Please reach out to your success manager if it's urgent.</>
          )}
        </p>
        <p className="mt-2 text-xs text-muted-foreground/70">{user?.email}</p>
        <Button variant="outline" onClick={logout} data-testid="pending-signout-btn" className="mt-6 h-11 w-full border-white/12 bg-white/[0.03] text-white hover:bg-white/[0.07]">
          <LogOut className="h-4 w-4" /> Sign out
        </Button>
      </div>
    </div>
  );
}
